/**
 * @param {Event} e - click event from the the event listener
 * @param {String} targetClassname - classname which element is allowed to click within
 * @param {Function} callback - the function that should run when clicking outside the target area
 */

let targetClassnames = ""
let localCallback = null

export default function (classnames, callback) {
    targetClassnames = classnames
    localCallback = callback
    document.addEventListener("click", closeDialog, true)
}

const closeDialog = function (e) {
    let match = false
    targetClassnames.forEach((targetClassname) => {
        if (e.target.classList.contains(targetClassname) || e.target.closest(`.${targetClassname}`)) {
            match = true
        }
    })

    if (!match) {
        document.removeEventListener("click", closeDialog, true)
        localCallback()
    }
}
